<h3 class="asc-menu-section">Einstellungen</h3>
<mat-nav-list class="fx-flex">
   @for (settingsNavigationItem of settingsNavigationItems; track $index) {
   <div>
      @if (settingsNavigationItem.entryPoints.length > 1) {
      <mat-list-item [matMenuTriggerFor]="menu" [ngClass]="{'active-menu': isActive(settingsNavigationItem)}">
         <asc-module-icon matListItemIcon [primary]="settingsNavigationItem.icons.primary" [secondary]="settingsNavigationItem.icons.secondary"></asc-module-icon>
         <span matListItemTitle>{{settingsNavigationItem.displayName}}</span>
      </mat-list-item>
      <mat-menu #menu="matMenu" [overlapTrigger]="true">
         @for (entryPoint of settingsNavigationItem.entryPoints; track $index) {
         <button mat-menu-item (click)="navigateTo(entryPoint)" [ngClass]="{'active-menu': activeEntryPoint === entryPoint}">
            <asc-module-icon [primary]="entryPoint.icons?.primary" [secondary]="entryPoint.icons?.secondary" size="sm"></asc-module-icon>
            {{entryPoint.displayName}}
         </button>
         }
      </mat-menu>
      }
      @else {
      <mat-list-item (click)="navigateTo(settingsNavigationItem.entryPoints[0])" [ngClass]="{'active-menu': isActive(settingsNavigationItem)}">
         <asc-module-icon matListItemIcon [primary]="settingsNavigationItem.icons.primary" [secondary]="settingsNavigationItem.icons.secondary"></asc-module-icon>
         <span matListItemTitle>{{settingsNavigationItem.displayName}}</span>
      </mat-list-item>
      }
   </div>
   }
</mat-nav-list>